export default "__VITE_ASSET__eea78042__"